import { cx } from '@linaria/core';
import { useUserIdentityState } from '@provider/user-identity';
import { LocationCard } from '../../location/molecule.location-card/_location-card.js';
import { heading } from './_portal-page.style.js';
import { wrapper, userGreeting, heading as heading$1 } from './molecule.location-section.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function LocationSection() {
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsxs("b", {
      className: userGreeting,
      children: ["Hej ", user?.name.split(" ")[0]]
    }), /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("h2", {
        className: cx(heading, heading$1),
        children: "Forts\xE6t, hvor du slap..."
      }), /*#__PURE__*/jsx(LocationCard, {})]
    })]
  });
}

export { LocationSection };
//# sourceMappingURL=molecule.location-section.js.map
